import html from "./paging.html";
import "./paging.css";
var pagingModel = /** @class */ (function () {
    function pagingModel(params) {
        var _this = this;
        this.params = params;
        this.currentPageIndex = ko.observable(0);
        this.tmpPageIndex = ko.observable(1);
        this.lastMaxPage = 10;
        this.lastPageIndex = 0;
        this.pages = ko.pureComputed(function () {
            var vm = _this.params.viewModel().data;
            // 需要的数据  pageIndex   totalPage
            // console.log("totalPage"+vm.totalPage);// 无数据
            _this.currentPageIndex(vm.pageIndex);
            var n = _this.currentPageIndex();
            if (!n)
                return;
            if (_this.lastPageIndex == n && _this.lastMaxPage == vm.totalPage)
                return _this.lastPages;
            var maxPage = vm.totalPage;
            if (maxPage == 0)
                maxPage = 1;
            _this.lastPages = [];
            for (var t = n - 4, i = t < 1 ? 1 : t; i < n; i++) {
                _this.lastPages.push(i);
            }
            for (var t = n + 4, m = t > maxPage ? maxPage : t, i = n; i <= m; i++) {
                _this.lastPages.push(i);
            }
            console.log(n);
            _this.lastPageIndex = n;
            _this.lastMaxPage = maxPage;
            console.log('pureComputed');
            return _this.lastPages;
        });
        // this.currentPageIndex.subscribe(n => {
        //    if (!n) return;
        //    let vm = this.params.viewModel() as { pageIndex: number, totalPage: number };
        //    let totalPages = vm.totalPage;
        //    let tmp = [];
        //    for (let t = n - 9, i = t < 1 ? 1 : t; i < n; i++)
        //        tmp.push(i);
        //    for (let t = n + 9, m = t > totalPages ? totalPages : t, i = n; i <= m; i++)
        //        tmp.push(i);
        //    this.pages(tmp); 
        // });
        this.currentPageIndex(1);
        this.currentPageIndex.subscribe(function (n) {
            _this.tmpPageIndex(n);
        });
    }
    pagingModel.prototype.goPrePage = function () {
        var vm = this.params.viewModel().data;
        if (vm.pageIndex <= 1)
            return;
        this.goPage(vm.pageIndex - 1);
    };
    pagingModel.prototype.goPage = function (pageIndex) {
        if (pageIndex <= 0) {
            this.currentPageIndex(pageIndex);
            return;
            //     pageIndex=1;
            //     let vm = (this.params.viewModel() as { data: Object }).data as { totalPage: number };
            //     if (pageIndex >= vm.totalPage + 1) return;
            //     this.currentPageIndex(pageIndex);
            //     this.params.data.pageIndex = pageIndex;
            //    // console.log(this.params.data);
            //     this.params.loadData();
        }
        else {
            // debugger;
            var vm = this.params.viewModel().data;
            if (pageIndex >= vm.totalPage + 1)
                return;
            this.params.data.pageIndex = pageIndex;
            // this.currentPageIndex(pageIndex);
            // console.log(this.params.data);
            this.params.loadData();
        }
    };
    pagingModel.prototype.goNextPage = function () {
        var vm = this.params.viewModel().data;
        if (vm.pageIndex >= vm.totalPage)
            return;
        this.goPage(vm.pageIndex + 1);
    };
    pagingModel.prototype.goOnePage = function () {
        this.goPage(1);
    };
    pagingModel.prototype.golastPage = function () {
        var vm = this.params.viewModel().data;
        this.goPage(vm.totalPage);
    };
    return pagingModel;
}());
ko.components.register("paging", {
    template: html,
    viewModel: {
        createViewModel: function (params, componentInfo) {
            // Return the desired view model instance, e.g.:
            return new pagingModel(params);
        }
    }
});
